import React, { useMemo, useState } from 'react';
import { Sheet } from '../common/Dialog';
import ModalActions from '../common/ModalActions';
import {
  AI30_COUPON_CODE,
  AI30_LANDING_PATH,
  AI30_PENDING_COUPON_KEY,
} from '../../utils/ai30Campaign';
import { trackInAppBrowserEvent } from '../../utils/eventTracker';
import {
  buildExternalBrowserUrl,
  getInAppBrowserName,
  isAndroidUserAgent,
  isIOSUserAgent,
  withCouponQuery,
} from '../../utils/inAppBrowser';

const resolveCurrentUrl = () => {
  if (typeof window === 'undefined') return 'https://whatquiz.co.kr/auth';
  let pending = '';
  try {
    pending = (localStorage.getItem(AI30_PENDING_COUPON_KEY) || '').trim();
  } catch {
    pending = '';
  }
  const coupon = pending || (
    window.location.pathname.startsWith(AI30_LANDING_PATH) ? AI30_COUPON_CODE : ''
  );
  return withCouponQuery(window.location.href, coupon);
};

const InAppBrowserLoginSheet = ({
  open,
  onClose,
  onContinueWithEmail,
}) => {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const isAndroid = isAndroidUserAgent(ua);
  const isIOS = isIOSUserAgent(ua);
  const browser = getInAppBrowserName(ua) || 'unknown';
  const [copied, setCopied] = useState(false);
  const currentUrl = useMemo(() => resolveCurrentUrl(), []);

  const handleExternal = async () => {
    trackInAppBrowserEvent('open_external_clicked', {
      browser,
      platform: isIOS ? 'ios' : (isAndroid ? 'android' : 'other'),
    });
    if (isAndroid) {
      window.location.href = buildExternalBrowserUrl(currentUrl, { userAgent: ua });
      return;
    }
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(currentUrl);
        setCopied(true);
        return;
      }
    } catch {
      // 클립보드 실패 시 아래 선택 안내로 넘어간다.
    }
    window.prompt('아래 링크를 복사한 뒤 Safari에서 열어주세요', currentUrl);
  };

  const handleEmail = () => {
    trackInAppBrowserEvent('email_continue_clicked', {
      browser,
      platform: isIOS ? 'ios' : (isAndroid ? 'android' : 'other'),
    });
    onContinueWithEmail?.();
    onClose?.();
  };

  return (
    <Sheet
      description={
        isIOS
          ? '이 앱 안 브라우저에서는 Google 로그인이 막혀 있어요. 이메일로 계속하거나, 오른쪽 위 메뉴에서 Safari로 열어주세요.'
          : '이 앱 안 브라우저에서는 Google 로그인이 막혀 있어요. 이메일로 계속하거나 Chrome으로 열어주세요.'
      }
      footer={(
        <ModalActions
          primary={{
            label: '이메일로 계속하기',
            onClick: handleEmail,
            testId: 'inapp-email-continue',
          }}
          secondary={
            isAndroid
              ? { label: 'Chrome으로 열기', onClick: handleExternal, testId: 'inapp-open-external' }
              : { label: copied ? '링크를 복사했어요' : '링크 복사', onClick: handleExternal, testId: 'inapp-open-external' }
          }
          testId="inapp-login-actions"
        />
      )}
      onClose={onClose}
      open={Boolean(open)}
      size="sm"
      testId="inapp-login-sheet"
      title="다른 방법으로 시작해주세요"
    />
  );
};

export default InAppBrowserLoginSheet;
